<template>
  <v-container class="pa-0 ma-0 pt-3 pb-8" style="height: 100%">
    <v-form ref="form" v-model="formValid" @submit.prevent>
      <v-row
        dense
        class="pa-0 ma-0"
        :style="{ rowGap: isMobile || isTablet ? '25px' : undefined }"
      >
        <!-- right Form -->
        <v-col cols="12" md="4">
          <div class="upload-box">
            <v-card-text class="pa-0 ma-0 button-upload" @click="newCoverUpload">
              <img
                :src="coverUrl || require('@/assets/payroll/placeH.png')"
                alt="choose img"
                height="100%"
                width="100%"
                class="uploadIMG"
                loading="lazy"
              />
              <v-container
                class="pa-0 ma-0 py-1 d-flex align-center justify-space-between"
              >
                <v-card-text class="pa-0 ma-0 text-body-2">(png,jpeg,jpg)</v-card-text>
                <v-spacer />
                <v-card-text class="pa-0 ma-0 text-body-2">(500 KB)</v-card-text>
              </v-container>
            </v-card-text>
            <input
              type="file"
              ref="coverInput"
              @change="CoverSelected"
              style="display: none"
            />
          </div>
        </v-col>
        <!-- Left Form  -->
        <v-col cols="12" md="8" class="pe-0">
          <v-container class="pa-0 ma-0 d-flex flex-column gap-7">
            <v-row dense class="ma-0 pa-0" style="row-gap: 22px">
              <v-col cols="12" md="6" class="pt-0">
                <v-text-field
                  v-model="workshopCode"
                  outlined
                  hide-details="auto"
                  :label="$t('workshopCode')"
                  class="rtl-text"
                  clearable
                  dense
                  :rules="[rules.required, rules.onlyNumber]"
                  inputmode="numeric"
                  pattern="[0-9]*"
                />
              </v-col>
              <v-col
                cols="12"
                md="6"
                :class="['pt-0', !(isMobile || isTablet) ? 'pe-0' : '']"
              >
                <v-text-field
                  v-model="rowContrat"
                  outlined
                  hide-details="auto"
                  :label="$t('rowContrat')"
                  class="rtl-text"
                  clearable
                  dense
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="workshopName"
                  outlined
                  hide-details="auto"
                  :label="$t('workshopName')"
                  class="rtl-text"
                  clearable
                  dense
                  :rules="[rules.required]"
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                md="6"
                :class="['', !(isMobile || isTablet) ? 'pe-0' : '']"
              >
                <v-text-field
                  v-model="CoFunder"
                  outlined
                  hide-details="auto"
                  :label="$t('CoFunder')"
                  class="rtl-text"
                  clearable
                  dense
                  :rules="[rules.required]"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="PremiumRate"
                  outlined
                  hide-details="auto"
                  :label="$t('PremiumRate')"
                  class="rtl-text"
                  clearable
                  dense
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                md="6"
                :class="['', !(isMobile || isTablet) ? 'pe-0' : '']"
              >
                <v-text-field
                  v-model="AccountNumber"
                  outlined
                  hide-details="auto"
                  :label="$t('AccountNumber')"
                  class="rtl-text"
                  clearable
                  dense
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                md="12"
                :class="['', !(isMobile || isTablet) ? 'pe-0' : '']"
              >
                <v-text-field
                  v-model="workshopADR"
                  outlined
                  hide-details="auto"
                  :label="$t('workshopADR')"
                  class="rtl-text"
                  clearable
                  dense
                  :rules="[rules.required]"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-col>
      </v-row>
    </v-form>

    <!--  snackbar --->
    <v-snackbar
      v-model="snakbar"
      :color="snakbarColor ? snakbarColor : 'primary'"
      top
      style="z-index: 1000000000000 !important"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          :loading="loading"
          color="white"
          text
          v-bind="attrs"
          @click="snakbar = !snakbar"
        >
          {{ $t("close") }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import General from "@/Mixins/general";

export default {
  name: "WorkshopForm",
  mixins: [General],
  props: {
    saveNew: {
      type: Boolean,
      default: false,
    },
    saveReturn: {
      type: Boolean,
      default: false,
    },
    edit: {
      type: Boolean,
      default: false,
    },
    clear: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      return: false,
      coverUrl: null,
      coverFile: null,
      workshopCode: null,
      rowContrat: null,
      workshopName: null,
      CoFunder: null,
      PremiumRate: null,
      AccountNumber: null,
      workshopADR: null,
      formValid: false,
      snakbar: false,
      snakbarColor: null,
      snakbarText: null,
    };
  },
  watch: {
    saveNew: {
      deep: true,
      handler(newVal) {
        if (newVal) {
          this.save(this.return);
        }
      },
    },
    saveReturn: {
      deep: true,
      handler(newVal) {
        if (newVal) {
          this.return = true;
          this.save(this.return);
        }
      },
    },
    clear: {
      deep: true,
      handler(newVal) {
        if (newVal) {
          this.coverUrl = null;
          this.coverFile = null;
          this.workshopCode = null;
          this.rowContrat = null;
          this.workshopName = null;
          this.CoFunder = null;
          this.PremiumRate = null;
          this.AccountNumber = null;
          this.workshopADR = null;
          this.$refs.coverInput.value = null;
          this.$emit("clear-form");
        }
      },
    },
  },
  computed: {
    rules() {
      return {
        required: (v) => !!v || this.$t("is-required"),
        onlyNumber: (v) => !v || /^[0-9]+$/.test(v) || this.$t("only numbers allowed"),
      };
    },
  },
  mounted() {
    if (this.$route.params.id) {
      this.getWorkShopById();
    }
  },
  methods: {
    save(val) {
      if (this.edit) {
        this.EditWorkshop(val);
      } else {
        this.createNewWorkshop(val);
      }
    },
    //upload & remove cover
    newCoverUpload() {
      this.$refs.coverInput.click();
    },
    CoverSelected(event) {
      const file = event.target.files[0];
      if (!file) return;
      this.coverFile = file;
      this.coverUrl = URL.createObjectURL(file);
    },
    removeCover() {
      this.coverFile = null;
      this.coverUrl = null;
      this.$refs.coverInput.value = null;
    },
    createNewWorkshop(val) {
      if (!this.$refs.form.validate()) {
        this.$emit("is-loading", false);
        this.$emit("again-ready-to-save");
      }
      if (this.$refs.form.validate()) {
        var app = this;
        app.loading = true;
        const formData = new FormData();
        formData.append("name", app.workshopName);
        formData.append("insurance_code", app.workshopCode || "");
        formData.append("contract_row", app.rowContrat || "");
        formData.append("employer_name", app.CoFunder || "");
        formData.append("insurance_rate", app.PremiumRate || "");
        formData.append("bank_account", app.AccountNumber || "");
        formData.append("address", app.workshopADR || "");
        app.$axios
          .post(this.$endpoint + "workshop", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            app.$emit("again-ready-to-save");
            let id_ = response.data.data.id;
            app.workshopName = null;
            app.workshopCode = null;
            app.rowContrat = null;
            app.CoFunder = null;
            app.PremiumRate = null;
            app.AccountNumber = null;
            app.workshopADR = null;
            app.coverUrl = null;
            app.snakbarText = app.$t("alert-register-success");
            app.snakbarColor = "success";
            app.snakbar = true;
            if (val) {
              app.return = false;
              app.$store.commit("REMOVE_COMPONENTS", {
                path: app.$route.path,
                name: app.$route.name,
                query: { ...app.$route.query },
                params: { ...app.$route.params },
              });
              app.$router.push("/payroll/workshop");
              app.create(id_);
            } else {
              app.create(id_);
            }
          })
          .catch((err) => {
            app.loading = false;
            app.serverErrorHandeler(err);
          })
          .finally(() => {
            app.$emit("is-loading", false);
            app.serverErrorHandeler(err);
            app.loading = false;
          });
      }
    },
    EditWorkshop(val) {
      if (!this.$refs.form.validate()) {
        this.$emit("is-loading", false);
        this.$emit("again-ready-to-save");
      }
      if (this.$refs.form.validate()) {
        var app = this;
        app.loading = true;
        let workshopId = this.$route.params.id;
        app.$axios
          .put(this.$endpoint + "workshop/" + workshopId, {
            name: app.workshopName,
            insurance_code: app.workshopCode,
            contract_row: app.rowContrat,
            employer_name: app.CoFunder,
            insurance_rate: app.PremiumRate,
            bank_account: app.AccountNumber,
            address: app.workshopADR,
          })
          .then((response) => {
            app.$emit("again-ready-to-save");
            let id_ = response.data.data.id;
            app.workshopName = response.data.data.name;
            app.workshopCode = response.data.data.insurance_code;
            app.rowContrat = response.data.data.contract_row;
            app.CoFunder = response.data.data.employer_name;
            app.PremiumRate = response.data.data.insurance_rate;
            app.AccountNumber = response.data.data.bank_account;
            app.workshopADR = response.data.data.address;
            app.coverUrl = response.data.data.logo_path.link;
            app.snakbarText = app.$t("alert-register-success");
            app.snakbarColor = "success";
            app.snakbar = true;
            if (val) {
              app.return = false;
              app.$store.commit("REMOVE_COMPONENTS", {
                path: app.$route.path,
                name: app.$route.name,
                query: { ...app.$route.query },
                params: { ...app.$route.params },
              });
              app.$router.push("/payroll/workshop");
              app.create(id_);
            } else {
              app.create(id_);
            }
          })
          .catch((err) => {
            app.loading = false;
            app.serverErrorHandeler(err);
          })
          .finally(() => {
            app.$emit("is-loading", false);
            app.serverErrorHandeler(err);
            app.loading = false;
          });
      }
    },
    getWorkShopById() {
      var app = this;
      app.loading = true;
      let workshopId = this.$route.params.id;
      app.$axios
        .get(app.$endpoint + "workshop/" + workshopId)
        .then((response) => {
          this.workshopCode = response.data.insurance_code;
          this.rowContrat = response.data.contract_row;
          this.workshopName = response.data.name;
          this.CoFunder = response.data.employer_name;
          this.PremiumRate = response.data.insurance_rate;
          this.AccountNumber = response.data.bank_account;
          this.workshopADR = response.data.address;
          this.coverUrl = response.data.logo.link;
        })
        .catch((err) => {
          app.serverErrorHandeler(err);
        })
        .finally(() => {
          app.initialLoading = false;
          app.paginationLoading = false;
        });
    },
    create(id) {
      var app = this;
      app.isLoading = true;
      let type = "workshopLogo";
      var formData = new FormData();
      formData.append("files[0]", this.coverFile);
      formData.append(
        "selectedFile[0]",
        JSON.stringify({
          link: this.coverUrl,
          extension: "." + this.coverFile.name.split(".").pop(),
          title: this.coverFile.name,
          _id: id,
          iconURL: "",
        })
      );
      formData.append("refId", id);
      formData.append("type", type);
      formData.append("select", "fileUpload");
      app.$axios
        .post(this.$endpoint + "createdetail", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) => {})
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => (this.isLoading = false));
    },
  },
};
</script>

<style scoped>
.upload-box {
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 100%;
  height: content;
}

.button-upload {
  color: #616161;
  max-height: 184px;
}
.uploadIMG {
  color: #616161;
  max-height: 184px;
  min-height: 184px;
}

::v-deep .upload-box .v-input__control {
  border: 2px dashed #ccc;
  border-radius: 8px;
  height: 100%;
}

::v-deep .upload-box .v-input__slot {
  justify-content: center;
  align-items: center;
  height: 100%;
}

::v-deep .upload-box input {
  display: none;
}
::-webkit-scrollbar {
  display: none;
}
</style>
